export const STRINGS = {
    required: "Este campo es requerido",
    type: "Tipo de caracteres incorrectos",
    formatDNI: "El DNI ingresado no tiene el formato correcto"
}